import { useParticipantDetails } from "../../context/participantDetails";
import React from "react";
import { useGetMyPrivilegesList } from "./dataloader";
import useOnOutSideClick from "../../../../shared/hooks/useOnOutSideClick";
import { useEnabledFeatures } from "../../context/enabledFeatures";

export default function useMyPrivilegesService() {
  const { participantDetails } = useParticipantDetails();
  const { isMyPrivilegesEnabled } = useEnabledFeatures();
  const containerRef = React.useRef<any>();
  const [showPrivilegesPanel, setShowPrivilegesPanel] = React.useState<boolean>(false);
  useOnOutSideClick({
    node: containerRef.current,
    onOutSideClick: () => {
      setShowPrivilegesPanel(false);
    }
  });

  const { data: myPrivilegesList } = useGetMyPrivilegesList(
    participantDetails?.registrationParticipantId,
    isMyPrivilegesEnabled
  );

  return { isMyPrivilegesEnabled, myPrivilegesList, showPrivilegesPanel, setShowPrivilegesPanel, containerRef };
}
